import React from 'react';

const FALLBACK_IMAGE = '/assets/ponpon-logo.svg';

const LockerItemCard = ({ 
  entry, 
  isPending = false,
  showTimestamp = true,
  showText = true 
}) => {
  const prizeName = entry?.prize?.name || entry?.name || 'Mystery prize';
  const prizeEmoji = entry?.prize?.image || entry?.image;
  const prizeImg =
    typeof entry?.prize?.imageUrl === 'string' && entry.prize.imageUrl.trim().length > 0
      ? entry.prize.imageUrl.trim()
      : typeof entry?.imageUrl === 'string' && entry.imageUrl.trim().length > 0
      ? entry.imageUrl.trim()
      : FALLBACK_IMAGE;
  const machineName = entry?.machineName || entry?.prize?.machineName || 'PonPon Machine';
  const timestamp = entry?.timestamp ? new Date(entry.timestamp) : null;
  const formattedDate = Number.isFinite(timestamp?.getTime())
    ? new Intl.DateTimeFormat(undefined, {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      }).format(timestamp)
    : 'Just now';

  // If showText is false, use simple box-style layout like empty locker slots
  if (!showText) {
    return (
      <div className="flex h-full w-full items-center justify-center rounded-3xl border border-dashed border-ponpon-navy/20 bg-white/50 p-2 sm:p-5">
        {prizeEmoji ? (
          <span className="text-xl sm:text-2xl">{prizeEmoji}</span>
        ) : (
          <img src={prizeImg} alt={prizeName} className="max-h-full max-w-full object-contain" />
        )}
      </div>
    );
  }

  return (
    <article
      className={`relative flex h-full w-full flex-col gap-4 rounded-3xl border p-5 shadow-sm transition ${
        isPending
          ? 'border-ponpon-coral/50 bg-gradient-to-br from-ponpon-coral/10 to-white/95 ring-2 ring-ponpon-coral/20'
          : 'border-white/70 bg-white/95 hover:-translate-y-1 hover:shadow-lg'
      }`}
    >
      {isPending && (
        <span className="absolute right-4 top-4 rounded-full bg-ponpon-coral px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-white shadow-sm">
          Pending
        </span>
      )}
      <div className="flex flex-1 items-center justify-center rounded-2xl p-4 sm:p-6 min-h-0 overflow-hidden">
        {prizeEmoji ? (
          <span className="text-4xl sm:text-5xl">{prizeEmoji}</span>
        ) : (
          <img src={prizeImg} alt={prizeName} className="max-h-full max-w-full object-contain" />
        )}
      </div>
      <div className="space-y-1">
        <h2 className="text-lg font-semibold text-ponpon-navy">{prizeName}</h2>
        <p className="text-xs font-medium uppercase tracking-wide text-ponpon-navy/55">
          {machineName}
        </p>
        {showTimestamp && (
          <p className={`text-xs ${isPending ? 'text-ponpon-coral/70 font-semibold' : 'text-ponpon-navy/60'}`}>
            {isPending ? 'Waiting for locker space' : formattedDate}
          </p>
        )}
      </div>
    </article>
  );
};

export default LockerItemCard;

